@if (!hideHeader) {
  <app-header class="lay-wrapper lay-wrapper--header mat-elevation-z8"></app-header>
}
<div
  class="app-content"
  role="main">
  @if (showFirstVisitPopup) {
    <app-first-visit-experience></app-first-visit-experience>
  }
  <div class="main-content-wrapper">
    <router-outlet
      style="height: 100%"
      id="main-content"
      [ngClass]="{ 'is-vis': isSidebarVisible }"
      [ngStyle]="{ width: sideBarWidth }"></router-outlet>
  </div>
  @if ((isAuthenticated$ | async) && (isAuthorized$ | async) && !healthcheckFail) {
    <app-sidebar
      #sidebar
      class="side-bar-main-item"
      role="navigation"
      aria-controls="coin-apps"
      [titles]="filteredDetails"
      [showSidebarOnStart]="false"
      [default]="false"
      (sidebarToggle)="onSidebarToggle()"
      (selectItem)="onItemSelect($event)">
      <app-apps
        id="coin-apps"
        role="menuitem"
        [class.full-height]="!hasDirects"
        [isExpanded]="isSidebarVisible && selectedSidebarItems.includes(0)"
        [ariaExpanded]="isSidebarVisible && selectedSidebarItems.includes(0)"
        [ngClass]="{ 'content-visible': selectedSidebarItems.includes(0) }"
        (toggle)="onItemToggle(0)"
        (closeMenu)="sidebar.onSidebarToggle()"></app-apps>
      <app-directs
        role="menuitem"
        [hidden]="!hasDirects"
        [isActive]="isSidebarVisible && selectedSidebarItems.includes(1)"
        [ariaExpanded]="isSidebarVisible && selectedSidebarItems.includes(1)"
        [ngClass]="{ 'content-visible': selectedSidebarItems.includes(1) }"
        (toggle)="onItemToggle(1)"
        (closeMenu)="sidebar.onSidebarToggle()"></app-directs>
    </app-sidebar>
  }
</div>
<app-footer></app-footer>
